import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// Components
import {
  BoardAndTrain,
  Boarding,
  BTAdult,
  BTPuppy,
  BuyATrainedPuppy,
  DayTraining,
  PrivateLessons,
  TrainingAll,
} from "../Components";

export const Training = () => {
  return (
    <>
      <Routes>
        <Route path="board-and-train" element={<BoardAndTrain />} />
        <Route path="board-and-train-adult" element={<BTAdult />} />
        <Route path="board-and-train-puppy" element={<BTPuppy />} />
        <Route path="boarding" element={<Boarding />} />
        <Route path="buy-a-trained-puppy" element={<BuyATrainedPuppy />} />
        <Route path="day-training" element={<DayTraining />} />
        <Route path="private" element={<PrivateLessons />} />
        <Route path="all" element={<TrainingAll />} />
        <Route path="/" element={<Navigate to="all" replace />} />
      </Routes>
    </>
  );
};
